import * as THREE from 'three'

export function createStars() {
    const startGeo = new THREE.BufferGeometry()
    const starPositions = new Float32Array( 1000 * 3 )

    const starRadius = $fx.rand() * 300

    for(let i = 0; i < 1000; i++) {
        const i3 = i * 3

        starPositions[i3    ] = ($fx.rand() - 0.5) * starRadius
        starPositions[i3 + 1] = ($fx.rand() - 0.5) * (starRadius * 2)
        starPositions[i3 + 2] = ($fx.rand() - 0.5) * starRadius
    }

    startGeo.setAttribute('position', new THREE.BufferAttribute(starPositions, 3))

    const starMaterial = new THREE.PointsMaterial({
        size: 0.01,
        sizeAttenuation: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending
    })

    const stars = new THREE.Points(startGeo, starMaterial)

    return stars
}

export function createNebula(r, g, b) {
    const startGeo = new THREE.BufferGeometry()
    const starPositions = new Float32Array( 3000 * 3 )

    const starRadius = $fx.rand() * 100

    for(let i = 0; i < 3000; i++) {
        const i3 = i * 3

        starPositions[i3    ] = Math.min(($fx.rand() - 0.5) * r, r * 0.5)
        starPositions[i3 + 1] = Math.min(($fx.rand() - 0.5) * g, g * 0.5)
        starPositions[i3 + 2] = Math.min(($fx.rand() - 0.5) * b, b * 0.5)
    }

    startGeo.setAttribute('position', new THREE.BufferAttribute(starPositions, 3))

    const starMaterial = new THREE.PointsMaterial({
        size: 0.01,
        sizeAttenuation: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        color: 0xffffff
    })

    const stars = new THREE.Points(startGeo, starMaterial)

    return stars
}